Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _airbnbPropTypes = require('airbnb-prop-types');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbWithTracking = require('airbnb-with-tracking');

var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);

var _withStyles = require('../../themes/withStyles');

var _DOMButtonOrA = require('../../private/DOMButtonOrA');

var _DOMButtonOrA2 = _interopRequireDefault(_DOMButtonOrA);

var _Spacing = require('../Spacing');

var _Spacing2 = _interopRequireDefault(_Spacing);

var _StatusLabel = require('../StatusLabel');

var _StatusLabel2 = _interopRequireDefault(_StatusLabel);

var _href = require('../../utils/propTypes/href');

var _href2 = _interopRequireDefault(_href);

var _textlike = require('../../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _removeFirefoxButtonPadding = require('../../utils/removeFirefoxButtonPadding');

var _removeFirefoxButtonPadding2 = _interopRequireDefault(_removeFirefoxButtonPadding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ANIMATION_DURATION_MS = 300;
var TIMING_FUNCTION = 'ease-out';

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  label: _textlike2['default'].isRequired,
  children: (0, _airbnbPropTypes.and)([_propTypes2['default'].node, (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].any, 'href', 'children')]),
  href: (0, _airbnbPropTypes.and)([_href2['default'], (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].any, 'href', 'children')]),
  onPress: _propTypes2['default'].func,
  selected: _propTypes2['default'].bool,
  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
  muted: _propTypes2['default'].bool,
  navigationOnly: _propTypes2['default'].bool,
  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
  spacedTabs: _propTypes2['default'].bool,
  statusLabel: function () {
    function statusLabel(props) {
      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (props.micro && props.statusLabel != null) {
        return new Error('A Tab cannot use both of these props: micro and statusLabel');
      }
      return _textlike2['default'].apply(undefined, [props].concat(rest));
    }

    return statusLabel;
  }(),
  ampVarsClickType: _propTypes2['default'].string,
  ampReplace: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool
}));

var defaultProps = {
  children: undefined,
  href: undefined,
  onPress: function () {
    function onPress() {}

    return onPress;
  }(),

  selected: false,
  micro: false,
  muted: false,
  navigationOnly: false,
  small: false,
  spacedTabs: false,
  statusLabel: null,
  ampVarsClickType: undefined,
  ampReplace: undefined,
  disabled: false
};

function Tab(_ref) {
  var css = _ref.css,
      href = _ref.href,
      label = _ref.label,
      micro = _ref.micro,
      muted = _ref.muted,
      navigationOnly = _ref.navigationOnly,
      onPress = _ref.onPress,
      selected = _ref.selected,
      small = _ref.small,
      spacedTabs = _ref.spacedTabs,
      statusLabel = _ref.statusLabel,
      styles = _ref.styles,
      ampVarsClickType = _ref.ampVarsClickType,
      ampReplace = _ref.ampReplace,
      disabled = _ref.disabled;

  return _react2['default'].createElement(
    _DOMButtonOrA2['default'],
    _extends({}, css(styles.text, styles.tab, micro && styles.tab_micro, muted && styles.text_muted, small && styles.tab_small, spacedTabs && styles.text_spacedTabs, selected && styles.tab_selected, disabled && styles.text_disabled), {
      href: href,
      onClick: onPress,
      onMouseUp: function () {
        function onMouseUp(e) {
          // Remove focus ring on buttons after clicking, but not when keyboard
          // tabbing around.
          e.currentTarget.blur();
        }

        return onMouseUp;
      }(),
      role: navigationOnly ? null : 'tab',
      ariaSelected: navigationOnly ? null : selected,
      ampVarsClickType: ampVarsClickType,
      ampReplace: ampReplace,
      disabled: disabled
    }),
    label,
    statusLabel && _react2['default'].createElement(
      _Spacing2['default'],
      { left: 1, vertical: -1, inline: true },
      _react2['default'].createElement(
        _StatusLabel2['default'],
        { book: true },
        statusLabel
      )
    )
  );
}

Tab.componentCategory = 'Core';
Tab.displayName = 'Tab';
Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;

exports['default'] = (0, _airbnbWithTracking2['default'])('Tab', ['onPress'])((0, _withStyles.withStyles)(function (_ref2) {
  var _text_spacedTabs;

  var unit = _ref2.unit,
      color = _ref2.color,
      font = _ref2.font,
      responsive = _ref2.responsive;
  return {
    tab: Object.assign({
      backgroundColor: color.clear,
      borderRadius: 0,
      borderWidth: 0,
      borderBottom: '2px solid ' + String(color.clear),
      bottom: '-1px',
      cursor: 'pointer',
      display: 'inline-block',
      margin: '0 ' + 4 * unit + 'px 0 0',
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 3 * unit,
      paddingBottom: 3 * unit,
      textDecoration: 'none',
      whiteSpace: 'nowrap',

      ':active': {
        // Remove focus ring while clicking, but not when keyboard tabbing around.
        outline: 0
      }

    }, (0, _removeFirefoxButtonPadding2['default'])()),

    text: Object.assign({}, font.textRegular, font.book),

    text_muted: {
      color: color.textMuted,

      '@media print': {
        color: color.printOverrides.textMuted
      }
    },

    text_disabled: {
      color: color.textDisabled
    },

    text_spacedTabs: (_text_spacedTabs = {}, _defineProperty(_text_spacedTabs, responsive.mediumAndAbove, {
      margin: '0 ' + 3 * unit + 'px 0 0'
    }), _defineProperty(_text_spacedTabs, responsive.largeAndAbove, {
      margin: '0 ' + 4 * unit + 'px 0 0'
    }), _text_spacedTabs),

    tab_selected: {
      borderBottom: '2px solid ' + String(color.textLink),
      color: color.textLink,
      transitionProperty: 'color',
      transitionDuration: ANIMATION_DURATION_MS + 'ms',
      transitionTimingFunction: TIMING_FUNCTION
    },

    tab_micro: Object.assign({}, font.textMicro, font.bold, {
      color: color.textDark, // This is in sync with <Link navigation>
      margin: '0 ' + 2 * unit + 'px 0 0',
      paddingTop: 1.5 * unit,
      paddingBottom: 1.5 * unit
    }),

    tab_small: Object.assign({}, font.textSmall, {
      margin: '0 ' + 3 * unit + 'px 0 0',
      paddingTop: 2 * unit,
      paddingBottom: 2 * unit
    })
  };
}, { pureComponent: true })(Tab));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Tabs/Tab.js
// module id = 145
// module chunks = 923280921217 19843951674672